import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable()
export class GraphqlClient {
  constructor(protected http: HttpClient) {}
  post<Input, Output>(
    url: string,
    query: string,
    variables: Input
  ): Observable<Output> {
    return this.http.post<Output>(url, { query, variables });
  }
}
